import { z } from 'zod';
/** POST /auth/:app/launch: redeems a Unified Access one-time launch code. */
export const launchSchema = z.object({ code: z.string().min(1) });
export const sessionUserSchema = z.object({
    id: z.string(),
    name: z.string(),
    username: z.string(),
});
export const sessionBranchSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
});
/** What GET /auth/:app/me and a successful launch/test-login return. */
export const sessionResponseSchema = z.object({
    user: sessionUserSchema,
    branch: sessionBranchSchema,
    services: z.array(z.string()),
    /** PDA session only: the session branch's current business date (fuel-pda.md section 4.1). */
    businessDate: z.iso.date().optional(),
    /** PDA session only: whether entries are frozen for a year operation. */
    frozen: z.boolean().optional(),
    /**
     * Absolute session expiry, ISO (unified-access.md section 3.1): 15 minutes
     * for the dashboard and operator, 12 hours for the PDA.
     */
    expiresAt: z.iso.datetime({ offset: true }),
    /**
     * Time left on the session when this answer was built. The web app counts
     * it from when the answer arrived, so a wrong device clock does not matter.
     */
    expiresInMs: z.number().int().nonnegative(),
});
/** CI-only bypass of the real Unified Access launch flow. */
export const testLoginSchema = z.object({ username: z.string().trim().min(1) });
//# sourceMappingURL=auth.contract.js.map